import { render, staticRenderFns } from "./setstaffModel.vue?vue&type=template&id=271344fc&scoped=true"
import script from "./setstaffModel.vue?vue&type=script&lang=js"
export * from "./setstaffModel.vue?vue&type=script&lang=js"
import style0 from "./setstaffModel.vue?vue&type=style&index=0&id=271344fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271344fc",
  null
  
)

export default component.exports